var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 9.22259V13.8726C18.3334 16.3309 16.3334 18.3309 13.8751 18.3309H6.12508C3.66675 18.3309 1.66675 16.3309 1.66675 13.8726V7.86426H18.1167C18.2417 8.23926 18.3084 8.62259 18.3251 9.03093C18.3334 9.08926 18.3334 9.16426 18.3334 9.22259Z",
    fill: "#FFB627"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.1167 7.86699H1.66675V5.35033C1.66675 3.31699 3.31675 1.66699 5.35008 1.66699H7.29175C8.65008 1.66699 9.07508 2.10866 9.61675 2.83366L10.7834 4.38366C11.0417 4.72533 11.0751 4.77533 11.5584 4.77533H13.8834C15.8584 4.76699 17.5417 6.06699 18.1167 7.86699Z",
    fill: "#FFB627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon02);
export default __webpack_public_path__ + "static/media/folder-icon-02.a0538563cbb9b6ea836c1c441343b05e.svg";
export { ForwardRef as ReactComponent };